import { render } from "./FixedScheduleDisplay.vue?vue&type=template&id=79b884f0&ts=true"
import script from "./FixedScheduleDisplay.vue?vue&type=script&lang=ts"
export * from "./FixedScheduleDisplay.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\joaog\\Documents\\GitHub\\friendly-fox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__